import state from './contentsState';
import mutations from './contentsMutations';
import getters from './contentsGetters';
import actions from './contentsActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
